import "./static/post_logo.png";

import "./post.css";
